module.exports = __webpack_public_path__ + "img/jorge-castro.5cfdd47c.jpg";